// extracted by mini-css-extract-plugin
module.exports = {"scrollCon":"_28X0h","textCon":"_3-TeE","pad_right":"_12IpE"};